import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import {
  fetchHomepageIfNeeded,
  fetchAudienceAcquisitionIfNeeded,
  setSelectedSidebarNav,
  logout
} from '../../actions'
import {
  makeAudienceAcquisitionTopicIdSelector,
  makeAudienceAcquisitionTopicSelector
} from '../../selectors'
import AudienceAcquisitionComponent from '../../components/acquisition/AudienceAcquisitionComponent'
import SidebarComponent from '../../components/sidebar/SidebarComponent'
import Profile from '../../classes/profile'
import { LS_HOMEPAGE_KEY } from '../../constants/local_storage'

class AudienceAcquisitionContainer extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    profile: Profile.PropTypes,
    history: PropTypes.object,
    match: PropTypes.object,
    topicId: PropTypes.string,
    homepage: PropTypes.object,
    audienceAcquisition: PropTypes.object,
    logout: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    fetchHomepage: PropTypes.func.isRequired,
    fetchNetworkDetails: PropTypes.func.isRequired,
    setShortcutPreference: PropTypes.func,
    shortcutPreference: PropTypes.string,
    selectedNav: PropTypes.string,
    isContentIntelligence: PropTypes.bool,
    isCatalogAnalysis: PropTypes.bool,
    isPerformanceAnalysis: PropTypes.bool,
    isAIInsights: PropTypes.bool,
    selectedSidebarNav: PropTypes.func
  }

  componentDidMount () {
    this.fetchData ()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.topicId !== this.props.topicId || prevProps.homepage.details !== this.props.homepage.details) {
      this.fetchData ()
    }
  }

  fetchData = () => {
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    if (!homepage) {
      if (this.props.profile && this.props.profile.groups.length > 0) {
        const groups = this.props.profile.groups
        const groupName = groups.filter(group => group !== 'Admin')[0]
        this.props.fetchHomepage(groupName)
      }
    }
    if (homepage || (!this.props.homepage.isFetching && this.props.homepage.details && this.props.homepage.details.network_entities && this.props.homepage.details.network_entities.length > 0) || this.props.shortcut) {
      this.props.fetchNetworkDetails(this.props.topicId)
    }
  }

  render () {
    const { profile, location, history, audienceAcquisition, shortcut, selectedNav, isContentIntelligence, isCatalogAnalysis, isPerformanceAnalysis, isAIInsights } = this.props
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    const myLogout = () => this.props.logout()
    return (
      <>
        <SidebarComponent
          isAdmin={this.props.isAdmin}
          profile={profile}
          logout={myLogout}
          location={location}
          homepage={homepage ? homepage : this.props.homepage}
          shortcut={shortcut}
          topicId={this.props.topicId}
          shortcutPreference={this.props.shortcutPreference}
          setShortcutPreference={this.props.setShortcutPreference}
          selectedSidebarNav={this.props.selectedSidebarNav}
          selectedNav={selectedNav}
          isContentIntelligence={isContentIntelligence}
          isCatalogAnalysis={isCatalogAnalysis}
          isPerformanceAnalysis={isPerformanceAnalysis}
          isAIInsights={isAIInsights}
        />
        <AudienceAcquisitionComponent
          isAdmin={this.props.isAdmin}
          profile={profile}
          history={history}
          homepage={homepage ? homepage : this.props.homepage}
          shortcut={shortcut}
          shortcutPreference={this.props.shortcutPreference}
          audienceAcquisition={audienceAcquisition}
          location={location}
        />
      </>
    )
  }
}

function mapStateToProps () {
  const topicIdSelector = makeAudienceAcquisitionTopicIdSelector()
  const audienceAcquisitionSelector = makeAudienceAcquisitionTopicSelector()
  return (state, ownProps) => {
    const profile = state.user.profile && new Profile(state.user.profile)
    const isAdmin = state.user.isAdmin
    const topicId = topicIdSelector(null, ownProps)
    const audienceAcquisition = audienceAcquisitionSelector(state, ownProps)
    const shortcut = ownProps.shortcut
    const homepage = state.homepage.list
    const selectedNav = state.sidebar.selectedNav
    const isContentIntelligence = state.sidebar.isContentIntelligence
    const isCatalogAnalysis = state.sidebar.isCatalogAnalysis
    const isPerformanceAnalysis = state.sidebar.isPerformanceAnalysis
    const isAIInsights = state.sidebar.isAIInsights

    return {
      isAdmin,
      profile,
      shortcut,
      homepage,
      topicId,
      audienceAcquisition,
      selectedNav,
      isContentIntelligence,
      isCatalogAnalysis,
      isPerformanceAnalysis,
      isAIInsights
    }
  }
}

function mapDispatchToProps (dispatch) {
  return {
    fetchHomepage: (groupName) => dispatch(fetchHomepageIfNeeded(groupName)),
    fetchNetworkDetails: (topicId) => dispatch(fetchAudienceAcquisitionIfNeeded(topicId)),
    selectedSidebarNav: (nav) => dispatch(setSelectedSidebarNav(nav)),
    logout: () => dispatch(logout())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AudienceAcquisitionContainer)